var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#FFF3ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_842)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0132 40.7053L41.7609 34.4868C41.9109 34.427 41.9998 34.2809 41.9998 34.1236V14.527C41.9608 14.549 41.9193 14.5679 41.8754 14.5833L41.8741 14.5805C30.3522 18.6292 33.3647 17.5689 24.0132 20.8549V40.7053H24.0132Z",
    fill: "#C78477"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23892 34.4866L24.0171 40.7025V20.8605L6.19118 14.6033C6.12416 14.5862 6.05985 14.5604 6.00006 14.5266V34.1235C6.00006 34.2808 6.08892 34.4269 6.2389 34.4867L6.23892 34.4866Z",
    fill: "#FFE5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 8.2344L6.00002 14.5466L24.0001 20.8589L42.0001 14.5466L24.0001 8.2344Z",
    fill: "#C78477"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0266 11.7319L17.828 10.3988L35.4564 16.8413L31.6551 18.1744L14.0266 11.7319Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6765 18.1668L31.7637 23.1719L32.2177 22.3425L32.5078 22.9745L32.9766 22.1206L33.2667 22.7526L33.7355 21.8987L34.0256 22.5307L34.4944 21.6768L34.7845 22.3089L35.2533 21.4549L35.5434 22.0869L35.5535 22.0701L35.5472 21.2781L35.4595 16.8402L35.4567 16.8412L31.6765 18.1668Z",
    fill: "#C31918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9508 27.2911C15.1914 27.3901 15.4054 27.5764 15.5566 27.7976C15.7097 28.0216 15.8045 28.2883 15.8045 28.5446C15.8045 28.6717 15.7807 28.7899 15.7372 28.8957C15.6779 29.04 15.5822 29.1556 15.4592 29.2366C15.3743 29.2926 15.2796 29.3305 15.1779 29.3484V29.9752C15.1779 30.1771 15.0142 30.3409 14.8122 30.3409C14.6102 30.3409 14.4465 30.1771 14.4465 29.9752V29.1591C14.2992 29.0579 14.1693 28.9251 14.0678 28.7765C13.9147 28.5526 13.82 28.2859 13.82 28.0295C13.82 27.9024 13.8437 27.7842 13.8873 27.6784C13.9466 27.5342 14.0422 27.4185 14.1652 27.3374C14.2873 27.2569 14.4299 27.2138 14.5842 27.2138C14.6994 27.2138 14.8232 27.2387 14.9508 27.2911ZM13.478 25.1731L16.5391 26.4314V25.6218C16.5391 25.315 16.4293 24.988 16.2523 24.7083C16.0787 24.4341 15.8462 24.2125 15.5968 24.11L14.1302 23.5072C14.0435 23.4716 13.9615 23.4547 13.8865 23.4547C13.806 23.4547 13.7364 23.4754 13.6815 23.5138C13.6216 23.5558 13.5716 23.622 13.5359 23.709C13.4986 23.7997 13.478 23.9137 13.478 24.0487L13.478 25.1731ZM12.5617 24.7965L12.712 24.8582V24.0487C12.712 23.8155 12.7539 23.6033 12.8298 23.4188C12.9218 23.1949 13.0643 23.0149 13.2447 22.8885C13.43 22.7586 13.6483 22.6887 13.8865 22.6887C14.0551 22.6887 14.2349 22.7249 14.4204 22.8011L15.887 23.4039C16.2866 23.5682 16.6444 23.8998 16.8986 24.3014C17.1494 24.6977 17.3051 25.1698 17.3051 25.6218V26.7463L17.7457 26.9273C18.0101 27.036 18.2449 27.2523 18.4099 27.5132C18.5716 27.7687 18.672 28.0743 18.672 28.3682V31.5875C18.672 31.7439 18.6431 31.8882 18.5909 32.0154C18.5255 32.1745 18.423 32.3032 18.2927 32.3945C18.1575 32.4893 17.9991 32.5404 17.8274 32.5404C17.7095 32.5404 17.5842 32.5152 17.4554 32.4623L12.2715 30.3315C12.0071 30.2228 11.7723 30.0065 11.6073 29.7456C11.4456 29.4901 11.3452 29.1846 11.3452 28.8906V25.6714C11.3452 25.5149 11.3741 25.3706 11.4263 25.2434C11.4917 25.0843 11.5942 24.9556 11.7245 24.8643C11.8597 24.7695 12.0181 24.7184 12.1898 24.7184C12.3077 24.7184 12.433 24.7436 12.5617 24.7965Z",
    fill: "#C31918"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.51754bfe4be4ca71f7581a85e90a0982.svg";
export { ForwardRef as ReactComponent };